import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../api/server";
import DescriptionSection from "../../components/shared/DescriptionSecion";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { handleImage } from "../../helpers";
import ContentEditor from "../../components/shared/ContentEditor";

const AboutUsShow = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const {
		params: { aboutUsSectionId },
	} = match;

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		reset,
		control,
	} = useForm();

	const {
		fields: descriptionFields,
		append: descriptionAppend,
		remove: descriptionRemove,
	} = useFieldArray({
		control,
		name: "descriptions",
	});
	const {
		fields: certFields,
		append: certAppend,
		remove: certRemove,
	} = useFieldArray({
		control,
		name: "certificates",
	});

	const [pictureImg, setPictureImg] = useState(userPlaceholder);

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "اضافة فئة جديدة",
				breadcrumb: "الفئات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		try {
			const initialData = await server(cookie).get(
				`/pages/about-us/sections/${aboutUsSectionId}`
			);
			setPictureImg(
				`${process.env.REACT_APP_MAIN_URL}/${initialData?.data?.data?.section?.image}`
			);
			setValue("title", initialData?.data?.data?.section?.sectionTitle);
			setValue("subTitle", initialData?.data?.data?.section?.subTitle);
			setValue("description", initialData?.data?.data?.section?.description);
			setValue("picturePath", initialData?.data?.data?.section?.image);
			if (initialData?.data?.data?.section?.descriptions)
				setValue(
					"descriptions",
					initialData?.data?.data?.section?.descriptions
				);
			if (initialData?.data?.data?.section?.certificates)
				setValue(
					"certificates",
					initialData?.data?.data?.section?.certificates
				);
		} catch (error) {
			console.log(error);
		}
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const imageResponse = async () => {
				if (data?.pictureUrl?.length <= 0) return data.picturePath;
				const dataForm = new FormData();
				dataForm.append("file", data.pictureUrl[0]);
				const imageData = await uploadServer(cookie).post("/upload", dataForm);
				return imageData?.data?.data?.file?.path;
			};
			const imageData = await imageResponse();

			const finalData = {
				...data,
				sectionTitle: data.title,
				// subTitle: data.subTitle,
				// description: data.description,
				image: imageData,
			};

			const dataResponse = await server(cookie).put(
				`/pages/about-us/sections/${aboutUsSectionId}`,
				{
					section: finalData,
				}
			);
			reset();
			onStart();
			history.push("/siteinfo/aboutUs/index");
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const handlePicture = async (name = false) => {
		if (!name) {
			const tempValue = getValues("pictureUrl");
			if (tempValue.length < 1) return;
			const blobUrl = URL?.createObjectURL(tempValue?.[0]);
			setValue(name ? name : "picturePath", blobUrl);
			setPictureImg(blobUrl);
		} else {
			const dataForm = new FormData();
			dataForm.append("file", getValues("pictureUrl")?.[0]);
			const imageData = await uploadServer(cookie).post("/upload", dataForm);
			setValue(name ? name : "picturePath", imageData?.data?.data?.file?.path);
		}
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	console.log(errors);

	const handleAddDescriptions = () => {
		if (descriptionFields.length + 1 > 12) {
			toast.info("اقص عداد للوصف هو 12");
			return;
		}
		descriptionAppend({});
	};
	const handleAddCert = () => {
		if (certFields.length + 1 > 12) {
			toast.info("اقص عداد للشهادات هو 12");
			return;
		}
		certAppend({});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					{aboutUsSectionId != "ma-alsltan-ant-alksban-aboutUs" && (
						<div className="card m-2">
							<div className="col-md-12">
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="titleAr">
											العنوان الرئيسي باللغة العربية
										</label>
										<input
											type="text"
											name="titleAr"
											id="titleAr"
											{...register("title.ar", {
												required: true,
											})}
										/>
									</div>
								</div>
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="titleEn">
											العنوان الرئيسي بالغة الانجليزية
										</label>
										<input
											type="text"
											name="titleEn"
											id="titleEn"
											{...register("title.en", {
												required: true,
											})}
										/>
									</div>
								</div>
							</div>
						</div>
					)}
					{aboutUsSectionId == "ma-alsltan-ant-alksban-aboutUs" ? (
						<>
							<div className="">
								<div className="col-6">
									<div className="card">
										<div className="card-body">
											<div className="form-item">
												<label htmlFor="picture">البانر</label>
												<input
													type="file"
													id="picture"
													{...register("pictureUrl", {
														required: false,
														onChange: () => handlePicture(),
													})}
												/>
												<img
													src={pictureImg}
													alt="avatar"
													className="imagePreview"
												/>
											</div>
										</div>
									</div>
									<input
										type="text"
										name=""
										id=""
										style={{ display: "none" }}
										{...register("picturePath")}
									/>
								</div>
								<div className="card">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="titleAr">
												العنوان الرئيسي باللغة العربية
											</label>
											<input
												type="text"
												name="titleAr"
												id="titleAr"
												{...register("title.ar", {
													required: true,
												})}
											/>
										</div>
									</div>
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="titleEn">
												العنوان الرئيسي بالغة الانجليزية
											</label>
											<input
												type="text"
												name="titleEn"
												id="titleEn"
												{...register("title.en", {
													required: true,
												})}
											/>
										</div>
									</div>
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="subTitleAr">
												العنوان الفرعي باللغة العربية
											</label>
											<input
												type="text"
												name="subTitleAr"
												id="subTitleAr"
												{...register("subTitle.ar", {
													required: true,
												})}
											/>
										</div>
									</div>
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="subTitleEn">
												العنوان الفرعي بالغة الانجليزية
											</label>
											<input
												type="text"
												name="subTitleEn"
												id="subTitleEn"
												{...register("subTitle.en", {
													required: true,
												})}
											/>
										</div>
									</div>
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionAr">
												الوصف باللغة العربية
											</label>
											{/* <textarea
												name="descriptionAr"
												id="descriptionAr"
												cols="30"
												rows="10"
												{...register("description.ar", {
													required: true,
												})}
											></textarea> */}
											<ContentEditor
												name={`description`}
												locale={"ar"}
												control={control}
												errors={errors}
											/>
										</div>
									</div>
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionEn">
												الوصف بالغة الانجليزية
											</label>
											{/* <textarea
												name="descriptionEn"
												id="descriptionEn"
												cols="30"
												rows="10"
												{...register("description.en", {
													required: true,
												})}
											></textarea> */}

											<ContentEditor
												name={`description`}
												locale={"en"}
												control={control}
												errors={errors}
											/>
										</div>
									</div>
									<div className="my-3 card p-3">
										<div className="card-title">التفاصيل</div>

										<DescriptionSection
											{...{
												descriptionFields,
												register,
												control,
												errors,
												descriptionRemove,
											}}
										/>
										<div className="col-md-4">
											<div className="card-body">
												<div className="form-item mt-3">
													<div
														className="bt bt-success btn-block secBtnForm"
														onClick={handleAddDescriptions}
													>
														اضافة الوصف
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</>
					) : aboutUsSectionId == "certificates" ? (
						<div className="col-12">
							<div className="card">
								<div className="row m-0">
									{certFields?.map((field, index) => {
										return (
											<div
												className="p-2 col-12 col-lg-6 col-xxl-4"
												key={index}
											>
												<div className="border border-1 border-light rounded-3 bg-light">
													<div className="card-body">
														<div className="row">
															<div className="form-item col-12 ">
																<div className="card">
																	<div className="card-body">
																		<div className="form-item">
																			<label htmlFor="picture">الصورة</label>
																			<input
																				type="file"
																				id="picture"
																				{...register("pictureUrl", {
																					required: false,
																					onChange: () =>
																						handlePicture(
																							`certificates.${index}.image`
																						),
																				})}
																			/>

																			<img
																				src={handleImage(
																					watch(`certificates.${index}.image`)
																				)}
																				alt="avatar"
																				className="imagePreview"
																				style={{
																					height: "200px",
																					width: "auto",
																				}}
																			/>
																		</div>
																	</div>
																</div>
																<input
																	type="text"
																	name=""
																	id=""
																	style={{ display: "none" }}
																	{...register("picturePath")}
																/>
															</div>
														</div>

														<div className="row">
															<div className="col">
																<div className="form-item">
																	<label htmlFor="descriptionAr">
																		عنوان الشهادة باللغة العربية
																	</label>
																	<input
																		type="text"
																		{...register(
																			`certificates.${index}.title.ar`
																		)}
																	/>
																</div>
															</div>
															<div className="col">
																<div className="form-item">
																	<label htmlFor="descriptionAr">
																		عنوان الشهادة باللغة الانجليزية
																	</label>
																	<input
																		type="text"
																		{...register(
																			`certificates.${index}.title.en`
																		)}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div>
													<div className="card-body">
														<div className="form-item mt-3">
															<div
																className="bt bt-danger btn-block secBtnForm"
																type="button"
																onClick={() => certRemove(index)}
															>
																احذف الشهادة
															</div>
														</div>
													</div>
												</div>
											</div>
										);
									})}
								</div>
								<div className="col-md-4">
									<div className="card-body">
										<div className="form-item mt-3">
											<div
												className="bt bt-success btn-block secBtnForm"
												onClick={handleAddCert}
											>
												اضافة شهادة
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					) : null}
					<div className="col-12">
						{/* <div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">البانر</label>
									<input
										type="file"
										id="picture"
										{...register("pictureUrl", {
											required: false,
											onChange: () => handlePicture(),
										})}
									/>
									<img src={pictureImg} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<input
							type="text"
							name=""
							id=""
							style={{ display: "none" }}
							{...register("picturePath")}
						/> */}
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default AboutUsShow;
